<section class="fxt-template-animation fxt-template-layout4 loaded">
  <div class="container-fluid" [ngStyle]="{'height':'calc(100vh - 32px)', 'padding':'0px'}">
    <div class="d-flex flex-wrap flex-sm-column flex-column flex-md-column flex-lg-column flex-xl-row resp-height">
      <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-7 pd-l-0 pd-r-0 tel">
        <div id="cf3" class="col-12">
          <img src="assets/Agora-new-login-page-version-1-left.jpg" class="lft-img-align bottom" />
          <img src="assets/Agora-new-login-left-img-2.jpg" class="lft-img-align top" />
          <div class="banner-cntnt-align col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div class="fxt-transformY-50 fxt-transition-delay-2">
              <h1>Effective meetings without the hassle!</h1>
            </div>
            <div class="fxt-transformY-50 fxt-transition-delay-3">
              <p class="p-banner-info">Revamp the way you have meetings with powerful electronic tools to
                facilitate
                meetings.
              </p>
            </div>
            <div class="fxt-transformY-50 fxt-transition-delay-3">
              <p class="p-banner-info">
                The perfect way to organize and keep track of your meetings and meeting notes.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column justify-content-start mar-t">
        <div class="row">
          <div class="col-12">
            <h2 [ngStyle]="{'font-size':'3em', 'margin':'0px 50px'}">Agora Password Creation</h2>
          </div>
          <div class="col-12" [ngStyle]="{'height':'calc(100vh - 126px)', 'overflow':'auto'}">

            <div class="fxt-form" [ngStyle]="{'margin':'7px 50px'}">
              <form [formGroup]="passwordCreationForm" (ngSubmit)="onSubmit()" novalidate>
                <div class="example-container-passwordcreation">

                  <p>

                    <!--password input filed-->
                    <mat-form-field [ngStyle]="{'width':'100%'}" color="primary">
                      <mat-label>Password</mat-label>
                      <!-- <mat-pass-toggle-visibility #toggle matSuffix></mat-pass-toggle-visibility> -->
                      <input matInput #password formControlName="password"
                        [ngClass]="{ 'is-invalid': isSubmitted && f.password.errors }" (focus)="toggler()"
                        (blur)="toggler()" type="password" required placeholder="Password">
                      <mat-hint aria-live="polite">
                        {{password.value.length}} / {{passwordPolicyMap['Max Password Length']}}
                      </mat-hint>

                      <mat-error *ngIf="passwordCreationError('password', 'required')">*Password is required</mat-error>
                    </mat-form-field>
                    <!--@angular-material-extensions/password-strength's main component-->
                    <mat-password-strength #passwordComponent [min]="passwordPolicyMap['Min Password Length']"
                      [max]="passwordPolicyMap['Max Password Length']" (onStrengthChanged)="onStrengthChanged($event)"
                      [password]="password.value">
                    </mat-password-strength>
                    <!--Password's strength info-->
                    <mat-password-strength-info *ngIf="showDetails" [passwordComponent]="passwordComponent">
                    </mat-password-strength-info>
                  </p>
                  <p>
                    <mat-form-field class="example-full-width" [ngStyle]="{'width':'100%'}">
                      <mat-label>Confirm Password </mat-label>
                      <input matInput type="password" formControlName="confirmPassword"
                        [ngClass]="{ 'is-invalid': isSubmitted && f.confirmPassword.errors }">
                      <mat-error *ngIf="passwordCreationError('confirmPassword', 'required')">*Confirm Password is
                        required</mat-error>
                      <mat-error *ngIf="passwordCreationError('confirmPassword', 'confirmedValidator')">Password must
                        match</mat-error>
                    </mat-form-field>
                  </p>
                  <div formArrayName="questionContainer">
                    <div *ngFor="let item of employees.controls; let i = index" [formGroupName]="i">
                      <!-- <div *ngFor = "let item of [].constructor(questionPolicyLength); let i = index" [formGroupName]="i"> -->
                      <mat-form-field class="example-full-width" [ngStyle]="{'width':'100%'}">
                        <mat-label>Security Question {{i + 1}}</mat-label>
                        <mat-select disableOptionCentering panelClass="common-drop-down-class" id="{{i}}+dpdown"
                          (selectionChange)="changeTracker($event, i)" required formControlName="questions"
                          [ngClass]="{ 'is-invalid': isSubmitted && f.questions.errors }">
                          <mat-option [disabled]="disabledSelectedItems(items.quesCode)"
                            *ngFor="let items of secQuesResponse; let j = index" id={{items.quesCode}}
                            value={{items.quesCode}}>{{items.quesDesc}}</mat-option>
                          <!-- <mat-option value="option2">Option 2</mat-option>
                                            <mat-option value="option3">Option 3</mat-option> -->
                        </mat-select>
                        <!-- <mat-select formControlName = "question"+i [ngClass]="{ 'is-invalid': isSubmitted && f.'questions'.errors }">
                                            <mat-option value="option1">Option 1</mat-option>
                                            <mat-option value="option2">Option 2</mat-option>
                                            <mat-option value="option3">Option 3</mat-option>
                                          </mat-select> -->
                        <!-- <mat-error id = "{{i}}+questionError" [ngStyle]="{'display':'none'}">Anser us rew</mat-error> -->

                        <mat-error *ngIf="employees.controls[i].get('questions')?.errors?.required">*Question is
                          required</mat-error>
                      </mat-form-field>
                      <!-- <span id = "{{i}}+questionError" [ngStyle]="{'display':'none'}">*Question is required</span> -->
                      <mat-form-field class="example-full-width" [ngStyle]="{'width':'100%'}">
                        <mat-label>Answer {{i + 1}}</mat-label>
                        <input type="password" id="{{i}}+answer" matInput formControlName="answers"
                          [ngClass]="{ 'is-invalid': isSubmitted && f.answers.errors }">
                        <!-- <input  matInput formControlName="answer"+i [ngClass]="{ 'is-invalid': isSubmitted && f.'answer'.errors }"> -->
                        <!-- <mat-error *ngIf="passwordCreationError('answers', 'required')">Answer is required</mat-error> -->
                        <mat-error *ngIf="employees.controls[i].get('answers')?.errors?.required">*Answer is
                          required</mat-error>
                        <!-- <mat-error id = "{{i}}+anserError">asds required</mat-error> -->
                        <!-- <div id = "{{i}}+anserError" hidden = "false">*Answer is required</div> -->
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- <p>
                                    <mat-form-field  class="example-full-width" [ngStyle]="{'width':'100%'}">
                                        <mat-label>Security Question 1</mat-label>
                                        <mat-select formControlName = "question2">
                                          <mat-option value="option1">Option 1</mat-option>
                                          <mat-option value="option2">Option 2</mat-option>
                                          <mat-option value="option3">Option 3</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="passwordCreationError('question2', 'required')">Question is required</mat-error>
                                      </mat-form-field>
                                      <mat-form-field  class="example-full-width" [ngStyle]="{'width':'100%'}">
                                        <mat-label>Answer 1</mat-label>
                                        <input  matInput formControlName="answer2" >
                                        <mat-error *ngIf="passwordCreationError('answer2', 'required')">Answer is required</mat-error>
                                      </mat-form-field>
                                  </p> -->
                  <div class="col-md-12 d-flex justify-content-center align-items-center">

                    <button class="" mat-raised-button color = "primary" [ngStyle]="{'width':'150px'}" type="submit">SAVE</button>

                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>